import RoutesMap from 'route_control/RouteControl'
import { NoticeList, NoticeDetails,NoticesAndEvents, PollList, PollDetails, EventList, EventDetails, EventCalendar } from 'pages/communication'

const CommunicationRoute = () => {
    return [
        {
            path: RoutesMap.NOTICES_AND_EVENTS.path,
            element: <NoticesAndEvents />,
        },
        {
            path: RoutesMap.NOTICE_LIST.path,
            element: <NoticeList />,
        },
        {
            path: RoutesMap.NOTICE_DETAILS.path,
            element: <NoticeDetails />,
        },
        {
            path: RoutesMap.POLL_LIST.path,
            element: <PollList />,
        },
        {
            path: RoutesMap.POLL_DETAILS.path,
            element: <PollDetails />,
        },
        {
            path: RoutesMap.EVENT_LIST.path,
            element: <EventList />,
        },
        {
            path: RoutesMap.EVENT_DETAILS.path,
            element: <EventDetails />,
        },
        {
            path: RoutesMap.EVENT_CALENDAR.path,
            element: <EventCalendar />,
        },
    ]
}

export default CommunicationRoute;